/* FS | Trade Landing Pages (fs-lp-*) — shared behaviour.
   Scrolly benefits (mobile), step progress rail (mobile),
   smooth anchors, and the device enquiry form. */
(function () {
  'use strict';

  /* Every fs-lp section renders the same script tag; the browser executes
     each occurrence, so guard against double-binding listeners. */
  if (window.__fsLpInit) return;
  window.__fsLpInit = true;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Smooth in-page anchors ---- */
  document.addEventListener('click', function (event) {
    var link = event.target.closest('.lp-scope a[href^="#"], .lp-header a[href^="#"]');
    if (!link) return;
    var target = document.getElementById(link.getAttribute('href').slice(1));
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth' });
  });

  /* ---- Mobile scrolly benefits ---- */
  function initScrolly(track) {
    var cards = track.querySelectorAll('.lp-scrolly__card');
    var counter = track.querySelector('.lp-scrolly__counter');
    var hint = track.querySelector('.lp-scrolly__hint');
    var headerOffset = 68;
    var active = -1;
    if (!cards.length) return;

    function onScroll() {
      if (!track.offsetHeight) return;
      var range = track.offsetHeight - (window.innerHeight - headerOffset);
      if (range <= 0) return;
      var p = Math.min(1, Math.max(0, (headerOffset - track.getBoundingClientRect().top) / range));
      var idx = Math.min(cards.length - 1, Math.floor(p * cards.length));
      if (idx === active) return;
      active = idx;
      cards.forEach(function (card, i) {
        card.classList.toggle('is-active', i === idx);
      });
      if (counter) {
        counter.textContent = '0' + (idx + 1) + ' / 0' + cards.length;
      }
      if (hint) hint.classList.toggle('is-done', idx === cards.length - 1);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }
  document.querySelectorAll('.lp-scrolly').forEach(initScrolly);

  /* ---- Step progress rail (mobile) ---- */
  var steps = document.querySelectorAll('.lp-step');
  if (steps.length) {
    var mobileSteps = window.matchMedia('(max-width: 1000px)');
    var onStepScroll = function () {
      if (!mobileSteps.matches) return;
      var trigger = window.innerHeight * 0.72;
      steps.forEach(function (el) {
        var r = el.getBoundingClientRect();
        el.classList.toggle('is-on', r.top + 22 < trigger);
        var span = r.height - 62;
        var p = span > 0 ? Math.min(1, Math.max(0, (trigger - r.top - 52) / span)) : 0;
        el.style.setProperty('--lp-line', String(reducedMotion ? Math.round(p) : p));
      });
    };
    window.addEventListener('scroll', onStepScroll, { passive: true });
    window.addEventListener('resize', onStepScroll);
    onStepScroll();
  }

  /* ---- Enquiry form ---- */
  function getUtm(name) {
    try {
      return new URLSearchParams(window.location.search).get(name) || '';
    } catch (e) {
      return '';
    }
  }

  function initEnquiryForm(card) {
    var form = card.querySelector('.lp-form');
    var success = card.querySelector('.lp-form-success');
    var errorEl = card.querySelector('.lp-form__error');
    if (!form || card.dataset.lpBound) return;
    card.dataset.lpBound = 'true';
    var inFlight = false;

    var resetBtn = card.querySelector('[data-lp-reset]');
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        card.classList.remove('is-done');
        if (success) success.classList.remove('is-visible');
        form.reset();
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (inFlight) return;
      inFlight = true;
      if (errorEl) errorEl.classList.remove('is-visible');

      var data = new FormData(form);
      var fullName = String(data.get('name') || '').trim();
      var spaceAt = fullName.indexOf(' ');
      var firstName = spaceAt === -1 ? fullName : fullName.slice(0, spaceAt);
      var lastName = spaceAt === -1 ? '-' : fullName.slice(spaceAt + 1).trim();

      var payload = {
        formType: 'device_enquiry',
        firstName: firstName,
        lastName: lastName || '-',
        email: String(data.get('email') || '').trim(),
        phone: String(data.get('telephone') || '').trim(),
        message: String(data.get('message') || '').trim(),
        privacyConsent: true,
        marketingOptIn: false,
        website: String(data.get('website') || ''),
        formData: {
          businessName: String(data.get('clinic') || '').trim(),
          businessType: String(data.get('businessType') || ''),
          jobRole: String(data.get('role') || '').trim(),
          product: String(data.get('product') || ''),
          brandsOfInterest: 'deesse-pro',
          sourceSite: window.location.hostname
        },
        sourcePageUrl: window.location.href,
        referrer: document.referrer || '',
        userAgent: navigator.userAgent,
        utmSource: getUtm('utm_source'),
        utmMedium: getUtm('utm_medium'),
        utmCampaign: getUtm('utm_campaign'),
        utmContent: getUtm('utm_content')
      };

      form.classList.add('is-busy');

      fetch(card.dataset.submitUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          return response.json().then(function (body) {
            if (!response.ok || body.error) {
              throw new Error(body.error || 'Something went wrong. Please try again.');
            }
            card.classList.add('is-done');
            if (success) success.classList.add('is-visible');
          });
        })
        .catch(function (err) {
          if (errorEl) {
            errorEl.textContent = err && err.message ? err.message : 'Something went wrong. Please try again.';
            errorEl.classList.add('is-visible');
          }
        })
        .finally(function () {
          inFlight = false;
          form.classList.remove('is-busy');
        });
    });
  }
  document.querySelectorAll('.lp-form-card[data-submit-url]').forEach(initEnquiryForm);
})();
